<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Brands
            <div class="settings-header__btn">
              <el-button
              type="success"
              size="mini"
              @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div class="setting-component">
            <div class="wrap">
              <div class="wrap__tree">

                <div class="nav-tree">
                  <el-button
                  @click="openModalCreate"
                  class="nav-tree__item"
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-plus">Add Brands</el-button>
                </div>

                <el-table
                  max-height="650"
                  :data="tableData"
                  :empty-text="$t('general_noData')"
                  style="width: 100%">
                  <el-table-column
                    label="ID"
                    type="index"
                    align="center"
                    width="70">
                  </el-table-column>
                  <el-table-column
                    prop="code"
                    label="Code"
                    width="160">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="Name">
                  </el-table-column>
                  <el-table-column
                    width="120"
                    align="center"
                    :label="$t('settings_accountThink_inventory_operations')">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="primary"
                        plain
                        icon="el-icon-edit"
                        @click="handleUpdate(scope.row)"></el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        plain
                        icon="el-icon-delete"
                        @click="handleDelete(scope.row)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>

              </div>
            </div>

            <create-update-modal @loadList="loadList" ref="createUpdateModal"></create-update-modal>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import CreateUpdateModal from '@/components/settings/scm/brands/CreateUpdateModal.vue'

  export default {
    name: "brands",
    components: {
      CreateUpdateModal,
    },
    data() {
      return {
        tableData: [],
        moment:moment,
      }
    },

    mounted() {
      this.loadList()
    },
    methods: {
      async loadList(){
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items/brands/list?companyId=${this.$route.query.companyId}`)
          this.tableData = data.list
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      openModalCreate(){
        this.$refs.createUpdateModal.openModal({ isCreate: true })
      },
      handleUpdate(row) {
        this.$refs.createUpdateModal.openModal({ isCreate: false, row })
      },
      async handleDelete(row) {
        this.$confirm('This will permanently delete. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(async () => {
          let loader = this.$loading.show();
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            await axios.delete(`/api/v1/items/brands?id=${row.id}`)
            await this.loadList()
            loader.hide()
            this.$message({ type: 'success', message: 'Delete completed' });
          } catch (error) {
            console.log('An error occurred:', error);
            loader.hide()
          }

        }).catch(() => {
          this.$message({ type: 'info', message: 'Delete canceled' });
        });
      },
      routerLink(page) {
        this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
      }
    }
  }
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}
.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
